import React, { PureComponent } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { saveAs } from 'file-saver';
import { toast } from 'react-toastify';

import { parseExcelData } from '../../common/services/utils';
import {
  getReport,
  getReportBreakdowns,
  getReportBreakdownsComparasion,
} from '../services/dashboard.service';
import Report from './report.component';

class Reports extends PureComponent {
  onGenerateReport =
    (getReportMethod, type) => async (id, dateFrom, dateTo, params) => {
      const newDateFrom = moment(dateFrom).format('DD-MM-YYYY');
      const newDateTo = moment(dateTo).format('DD-MM-YYYY');

      const data = await getReportMethod(newDateFrom, newDateTo, id, params);

      if (data.length > 0) {
        const newData = parseExcelData(data);

        const blob = new Blob([newData], {
          type: 'text/csv;charset=utf-8;',
        });

        saveAs(blob, `Raport-${type}-${newDateFrom}-${newDateTo}.csv`);
      } else {
        toast.error('Brak danych w wybranym okresie');
      }
    };

  render() {
    const { isAdmin } = this.props;

    return (
      <>
        <div className="content row">
          {isAdmin && (
            <Report
              title="Raport Sprzedaży"
              onGenerateReport={this.onGenerateReport(getReport, 'Sprzedaż')}
            />
          )}
          {isAdmin && (
            <Report
              title="Raport Awarii"
              onGenerateReport={this.onGenerateReport(
                getReportBreakdowns,
                'Awarie',
              )}
            />
          )}
          <Report
            title="Raport Porównawczy"
            onGenerateReport={this.onGenerateReport(
              getReportBreakdownsComparasion,
              'Porównawczy',
            )}
            filters={isAdmin ? [{ id: 'nip', label: 'NIP' }] : []}
          />
        </div>
      </>
    );
  }
}

Reports.propTypes = {
  isAdmin: PropTypes.bool,
};

Reports.defaultProps = {
  isAdmin: false,
};

export default Reports;
